// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg fill=%27%23888%27 height=%2718%27 viewBox=%270 0 24 24%27 width=%2718%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M7 10l5 5 5-5z%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `   .notice-section {
     max-width: 900px;
     margin: 0 auto;
   }

   /* 상단 제목 + 검색창 */
   .notice-header {
     display: flex;
     justify-content: space-between;
     align-items: center;
     padding: 40px 0px;
     padding-bottom: 15px;
     border-bottom: 1px solid #ccc;
   }

   .notice-header h2 {
     font-size: 1.5rem;
     margin: 0;
   }

   .search-box {
     display: flex;
     align-items: center;
     border: 1px solid #ccc;
     padding: 8px 16px;
     border-radius: 4px;
   }

   .search-box input {
     border: none;
     outline: none;
     margin-left: 5px;
   }

   /* 리스트 영역 */
   .notice-list {
     list-style: none;
     padding: 0;
     margin: 0;
   }

   .notice-list li:hover {
     background: #f9f9f9;
   }

   .notice-list li {
     display: flex;
     justify-content: space-between;
     align-items: center;
     padding: 12px 0;
     border-bottom: 1px solid #eee;
     cursor: pointer;
   }

   .notice-title {
     flex: 1;
     text-align: left;
   }

   .notice-meta {
     display: flex;
     gap: 30px;
     font-size: 0.9rem;
     color: #555;
     white-space: nowrap;
   }

   /* 페이지네이션 */
   /* .pagination {
     display: flex;
     justify-content: center;
     align-items: center;
     gap: 15px;
     margin: 25px 0 0;
     padding-bottom: 20px;
   }

   .pagination button {
     background: none;
     border: none;
     font-size: 1rem;
     cursor: pointer;
     color: #000;
   }

   .pagination .active {
     font-weight: bold;
     text-decoration: underline;
   } */

   /* FAQ */


   details {
     border-bottom: 1px solid #e5e5e5;
     padding: 30px 0;
   }

   details:hover {
     background: #f9f9f9;
   }


   summary {
     font-size: 18px;
     font-weight: 600;
     cursor: pointer;
     list-style: none;
     padding-left: 16px;
     /* 전체 들여쓰기 */
     position: relative;
   }

   summary::after {
     content: '+';
     position: absolute;
     right: 16px;
     font-weight: bold;
     font-size: 24px;
     line-height: 1;
     transition: transform 0.3s;
   }

   details[open] summary::after {
     content: '−';
     font-size: 24px;
   }

   .faq-answer {
     margin-top: 12px;
     font-size: 15px;
     color: #444;
     line-height: 1.8;
     padding-left: 16px;
     /* 답변도 들여쓰기 */
   }

   .label-q {
     color: #0072ce;
     font-weight: 700;
     margin-right: 6px;
   }

   .label-a {
     color: #ff6600;
     font-weight: 700;
     margin-right: 6px;
   }

   /* post */
   .wrap {
     width: 100%;
     max-width: 900px;
     margin: 0 auto;
     padding: 16px 0px;
     border-bottom: 1px solid #ddd;
     margin-bottom: 40px;
   }

   /* 2025.10.21 back css 삭제 */
   /* .back {
     align-items: center;
     padding: 0px;
   } */

   /* 헤더 영역 */
   .notice-detail-head {
     border-bottom: 1px solid #ddd;
     padding-bottom: 16px;
     margin-bottom: 25px;
   }

   .notice-detail-info {
     display: flex;
     justify-content: space-between;
     font-size: 14px;
     color: #666;
   }

   /* 2025.10.21 css 삭제 */
   /* .notice-detail-info span {
     margin-left: 12px;
   } */

   /* 본문 */
   .notice-detail-body {
     font-size: 15px;
     line-height: 1.7;
     margin-bottom: 40px;
     white-space: pre-line;
   }

   /* 첨부파일 */
   .notice-detail-file {
     margin-bottom: 20px;
     text-align: right;
   }

   .notice-detail-file a {
     display: inline-block;
     padding: 6px 10px;
     border: 1px solid #ccc;
     border-radius: 4px;
     font-size: 14px;
     color: #0048FF;
     text-decoration: none;
     background: #f9f9f9;
   }


   .notice-detail-file svg {
     flex-shrink: 0;
     vertical-align: middle;
   }

   /* 버튼 */
   .notice-detail-btn {
     text-align: center;
     /* 2025.10.21 btn css 수정 */
     /* margin-top: 40px; */
     margin-bottom: 40px;
   }

   .notice-detail-btn button {
     background: #000;
     padding: 12px 36px;
     border: 2px solid #000;
     border-radius: 4px;
     font-size: 15px;
     cursor: pointer;
   }

   .notice-detail-btn button>a {
     color: #fff;
   }

   .notice-detail-btn button:hover {
     background: #ffffff;
   }

   .notice-detail-btn button:hover>a {
     color: #000;
   }

   /* 문의글 */
   /* 2025.10.15 css 추가 */
   .inquiry-section {
     width: 100%;
     max-width: 900px;
     margin: 0 auto;
     padding: 16px 0px;
   }

   .inquiry-section .wrap {
     width: 100%;
     max-width: 900px;
     margin: 0 auto;
     padding: 24px;
     box-sizing: border-box;
     border-bottom: 1px solid #ddd;
     margin-bottom: 40px;
     background: transparent;
   }

   /* 2025.10.15 css 추가 */
   .answer-section {
     width: 100%;
     max-width: 900px;
     margin: 0 auto;
     padding: 16px 0px;
   }


   .answer-section .wrap {
     width: 100%;
     max-width: 900px;
     margin: 0 auto;
     padding: 24px;
     box-sizing: border-box;
     border-radius: 8px;
     border-bottom: 1px solid #ddd;
     margin-bottom: 40px;
     background: transparent;
     background: #fafafa;
     border-left: 4px solid #0048FF;
     border-radius: 8px;
     padding: 24px 32px;
     box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
   }

   .post-title {
     font-size: 20px;
     font-weight: bold;
     margin-bottom: 10px;
   }

   .notice-detail-info {
     display: flex;
     justify-content: space-between;
     align-items: center;
   }

   .notice-detail-info .category {
     font-weight: 600;
     color: #333;
   }

   /* 2025.10.21 css 삭제 */
   .notice-detail-info .meta span {
     /* margin-left: 12px; */
     color: #777;
   }

   .notice-detail-file a {
     display: inline-flex;
     align-items: center;
     gap: 6px;
   }

   .contact-button {
     text-align: right;
   }

   .contact {
     color: #000000;
     font-weight: 400;
     font-size: 14px;
     margin: 16px 0;
     border: 1px solid #ddd;
     width: fit-content;
     padding: 6px 12px;
     border-radius: 4px;
     background: #f5f5f5;
     box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
     cursor: pointer;
     transition: 0.3s;
   }

   .contact:hover {
     background: #e0e0e0;
   }

   /* 반응형 */
   /* @media (max-width: 600px) {
     .wrap {
       padding: 20px;
       margin: 0 12px 36px 12px;
     }

     .notice-detail-info {
       flex-direction: column;
       align-items: flex-start;

     }

     .answer-section .wrap {
       padding: 20px 20px 20px 20px;
       margin: 0 16px 36px 16px;
     }
   } */



   @media (max-width: 768px) {

     /* 2025.10.21 css 위치 수정 */
     /* .wrap {
       padding: 20px;
       margin: 0 12px 36px 12px;
     } */

     .notice-detail-info {
       flex-direction: column;
       align-items: flex-start;

     }

     .answer-section .wrap {
       padding: 20px 20px 20px 20px;
       margin: 0 16px 36px 16px;
     }

     /* 공지사항 전체 영역 */
     /* .notice-section,
     .wrap {
       max-width: 100%;
       padding: 0 16px;
     } */
     /* 2025.10.21 게시판 영역 수정 */
     .notice-section {
       max-width: 100%;
       margin: 16px;
       padding-top: 16px;
     }

     .wrap {
       margin: 0 16px;
     }

     /* ------------------------ */

     /* 상단 제목 + 검색창 */
     .notice-header {
       align-items: flex-start;
       gap: 15px;
       padding: 30px 0 15px;
     }

     .notice-header h2 {
       font-size: 1.3rem;
     }

     .search-box {
       width: 300px;
       padding: 6px 12px;
     }

     .search-box input {
       width: 100%;
     }

     /* 리스트 */
     .notice-list li {
       flex-direction: column;
       align-items: flex-start;
       gap: 6px;
     }

     .notice-title {
       width: 100%;
       font-size: 0.95rem;
     }

     .notice-meta {
       gap: 15px;
       font-size: 0.8rem;
       flex-wrap: wrap;
     }

     /* 페이지네이션 */
     .pagination {
       gap: 10px;
       margin-top: 20px;
     }

     .pagination button {
       font-size: 0.9rem;
     }

     /* FAQ */
     summary {
       font-size: 16px;
       padding-left: 10px;
     }

     summary::after {
       right: 10px;
       font-size: 20px;
     }

     .faq-answer {
       padding-left: 10px;
       font-size: 14px;
     }

     /* 게시글(post) 상세 */
     .notice-detail-head {
       padding-bottom: 12px;
       margin-bottom: 20px;
     }

     .notice-detail-info {
       flex-direction: column;
       align-items: flex-start;
       gap: 6px;
       font-size: 13px;
     }

     .notice-detail-body {
       font-size: 14px;
       line-height: 1.6;
       margin-bottom: 30px;
     }

     .notice-detail-file {
       text-align: left;
       font-size: 13px;
     }

     .notice-detail-file a {
       font-size: 13px;
       padding: 6px 8px;
     }

     /* 버튼 */
     .notice-detail-btn {
       margin-top: 30px;
     }

     .notice-detail-btn button {
       width: 100%;
       max-width: 300px;
       padding: 12px 0;
       font-size: 14px;
     }
   }

   /* 문의사항 페이지 */
   /* 2025.10.15 문의사항 페이지 css 옮김 */
   .contact-list {
     list-style: none;
     padding: 0;
     margin: 0;
     border-top: 1px solid #ddd;
   }

   .contact-list li {
     padding: 16px 12px;
     border-bottom: 1px solid #ddd;
     display: flex;
     flex-direction: column;
     transition: 0.2s;
   }

   .contact-list li:hover {
     background: #f9f9f9;
   }


   .contact-header {
     display: flex;
     justify-content: space-between;
     align-items: flex-start;
     gap: 12px;
   }

   .contact-title {
     display: flex;
     align-items: center;
     flex-wrap: wrap;
     font-size: 16px;
     font-weight: 500;
     color: #272727;
     gap: 8px;
     flex: 1;
     min-width: 0;
     word-break: break-all;
   }

   .contact-title svg {
     flex-shrink: 0;
   }

   .contact-status {
     font-size: 14px;
     color: #777;
   }



   /*'답변완료' */
   .answer-status {
     font-size: 14px;
     font-weight: 500;
     color: #008000;
     background: #e9f6eb;
     padding: 4px 10px;
     border-radius: 12px;
     white-space: nowrap;
     flex-shrink: 0;
   }

   /* '답변대기' */
   .answer-status2 {
     font-size: 14px;
     font-weight: 500;
     color: #a30000;
     background: #f6e9e9;
     padding: 4px 10px;
     border-radius: 12px;
     white-space: nowrap;
     flex-shrink: 0;
   }

   .contact-meta {
     display: flex;
     gap: 12px;
     margin-top: 6px;
     font-size: 14px;
     color: #777;
   }

   .contact-meta span {
     white-space: nowrap;
   }

   /* 반응형 */
   @media (max-width: 600px) {
     .contact-header {
       align-items: flex-start;
       gap: 6px;
     }

     .answer-status {
       align-self: flex-end;
       /* ✅ 모바일에서 오른쪽 유지 */
       font-size: 13px;
       padding: 3px 8px;
     }

     .answer-status2 {
       align-self: flex-end;
       /* ✅ 모바일에서 오른쪽 유지 */
       font-size: 13px;
       padding: 3px 8px;
     }

     .contact-title {
       font-size: 14px;
     }

     .contact-meta {
       align-items: flex-start;
       font-size: 13px;
     }
   }

   .contact-meta span {
     white-space: nowrap;
   }

   /* 오른쪽 '답변완료' 표시 */
   .answer-status {
     font-size: 14px;
     font-weight: 500;
     color: #008000;
     /* 초록색 */
     background: #e9f6eb;
     padding: 4px 10px;
     border-radius: 12px;
     white-space: nowrap;
   }

   /* 반응형 */
   @media (max-width: 600px) {
     .contact-list li {
       padding: 12px 8px;
     }

     .contact-title {
       font-size: 14px;
       flex-wrap: wrap;
     }

     .contact-status {
       margin-left: 4px;
       font-size: 13px;
     }

     .contact-meta {
       flex-direction: column;
       gap: 4px;
       font-size: 13px;
     }
   }


   /* 2025.10.22 문의글 작성 css 추가 */
   :root {
     --accent: #0048ff;
     --border: #e5e5e5;
     --bg: #fff;
     --text: #222;
     --muted: #888;
     --file-bg: #f8f9fc;
     font-family: "Noto Sans KR", sans-serif;
   }

    /* 2025.10.24 class 변경
    inquiry-section > inquiry-contect */
   .inquiry-contect {
     max-width: 900px;
     margin: 60px auto;
     background: var(--bg);
     border: 1px solid var(--border);
     border-radius: 12px;
     padding: 40px 50px;
     box-sizing: border-box;
   }

   .inquiry-contect h2 {
     font-size: 24px;
     font-weight: 700;
     margin-bottom: 28px;
   }

   .inquiry-form {
     display: flex;
     flex-direction: column;
     gap: 22px;
   }

   .form-group {
     display: flex;
     flex-direction: column;
     gap: 8px;
   }

   .form-group select {
     appearance: none;
     /* 브라우저 기본 화살표 제거 */
     -webkit-appearance: none;
     -moz-appearance: none;
     background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat right 14px center;
     background-size: 18px;
     padding-right: 40px;
     /* 화살표 공간 확보 */
   }

   .form-group label {
     font-weight: 600;
     color: var(--text);
   }

   .form-group input[type="text"],
   .form-group textarea,
   .form-group select {
     padding: 12px 14px;
     border: 1px solid var(--border);
     border-radius: 8px;
     font-size: 15px;
     box-sizing: border-box;
     font-family: inherit;
     color: var(--text);
   }

    /* 2025.10.27 css명 수정 */
   .form-group textarea {
     resize: vertical;
     min-height: 180px;
     line-height: 1.6;
   }

   /* 첨부파일 */
   .file-box {
     display: flex;
     flex-direction: column;
   }

   .file-input-wrapper {
     display: flex;
     align-items: center;
     justify-content: space-between;
     border: 1px solid var(--border);
     border-radius: 8px;
     padding: 8px 14px;
     background: #fff;
   }

   .file-placeholder {
     color: #777;
     font-size: 14px;
   }

   .file-btn {
     background: #ddd;
     padding: 8px 16px;
     border-radius: 6px;
     font-size: 14px;
     font-weight: 600;
     cursor: pointer;
     transition: 0.2s;
   }

   .file-btn:hover {
     opacity: 0.9;
   }

   .file-info {
     font-size: 13px;
     margin-left: 6px;
     color: var(--muted);
   }


   .file-list {
     margin-top: 10px;
     display: flex;
     flex-direction: column;
     gap: 4px;
   }

   .file-item {
     display: flex;
     align-items: center;
     gap: 4px;
     padding: 4px 0;
     font-size: 14px;
     color: var(--accent);
     line-height: 1.4;
   }

   .file-item svg {
     width: 14px;
     height: 14px;
     flex-shrink: 0;
     vertical-align: middle;
     margin-top: -0.5px;
   }

   .file-item .file-name {
     flex: none;
     overflow: hidden;
     text-overflow: ellipsis;
     white-space: nowrap;
     color: var(--accent);
     cursor: pointer;
     margin-right: 4px;
     display: flex;
     align-items: center;
   }

   .file-item .remove-btn {
     color: #999;
     background: none;
     border: none;
     font-size: 15px;
     cursor: pointer;
     padding: 0 2px;
     line-height: 1;
     display: flex;
     align-items: center;
     justify-content: center;
     transition: 0.2s;
   }

   .file-item .remove-btn:hover {
     color: #ff4444;
   }

   /* 미리보기 행 확장 */
   .preview-row {
     align-items: flex-start;
   }

   /* 기존 editor-area 대신 새 preview-area */
   .preview-area {
     flex: 1;
     border: 1px solid #ccc;
     border-radius: 6px;
     background-color: #f6f8fb;
     padding: 20px;
     text-align: center;
     color: #555;
     min-height: 300px;
     /* 기본 높이 크게 */
     display: flex;
     justify-content: center;
     align-items: center;
     overflow: hidden;
   }

   /* 업로드된 이미지 미리보기용 */
   .preview-area img {
     max-width: 100%;
     max-height: 100%;
     object-fit: contain;
     border-radius: 4px;
   }

   /* 버튼 영역 */
   .form-buttons {
     display: flex;
     justify-content: flex-end;
     gap: 10px;
     margin-top: 30px;
   }

   /* 2025.10.27 버튼 class 수정 */
   .buttons-form {
     border: none;
     padding: 12px 28px;
     border-radius: 8px;
     font-size: 15px;
     font-weight: 600;
     cursor: pointer;
     transition: 0.2s ease;
   }

  .buttons-form .submit {
     background: var(--accent);
     color: #fff;
   }

   .buttons-form .cancel {
     background: #ddd;
     color: #333;
   }

   .buttons-form:hover {
     opacity: 0.9;
   }

   @media (max-width: 768px) {
     .inquiry-section {
       padding: 24px 20px;
       margin: 40px 12px;
     }

     .inquiry-section h2 {
       font-size: 20px;
     }

     .file-upload-wrapper {
       flex-direction: column;
       align-items: flex-start;
       gap: 6px;
     }
   }

   /* 2025.10.23 비밀번호 입력란 css 추가 */

   /* 배경 */
   .popup-overlay {
      display: none; /* 기본 비표시 */
     position: fixed;
     top: 0;
     left: 0;
     width: 100%;
     height: 100%;
     background: rgba(0, 0, 0, 0.5);
     display: flex;
     justify-content: center;
     align-items: center;
     z-index: 1000;
   }

   /* 팝업 본체 */
   .popup-content {
     position: relative;
     background: #fff;
     border-radius: 12px;
     padding: 30px 40px;
     width: 600px;
     box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
     font-family: "Noto Sans KR", sans-serif;
   }

     .password-box {
      width: 320px;
      padding: 30px 20px;
      border: 1px solid #ddd;
      border-radius: 6px;
      text-align: center;
      box-shadow: 0 2px 6px rgba(0,0,0,0.05);
      background-color: #fff;
    }

    .password-box h2 {
      font-size: 18px;
      margin-bottom: 8px;
      font-weight: 600;
    }

    .password-box p {
      font-size: 14px;
      color: #333;
      margin-bottom: 16px;
      font-weight: 500;
    }

    .password-box input {
      width: 70%;
      padding: 8px;
      border: 1px solid #ccc;
      border-radius: 4px;
      margin-bottom: 20px;
    }

    .button-area {
      display: flex;
      justify-content: center;
      gap: 10px;
    }

    .button-area button {
      padding: 6px 16px;
      border: 1px solid #ccc;
      background-color: #f9f9f9;
      border-radius: 4px;
      cursor: pointer;
      font-size: 14px;
    }

    .button-area button:hover {
      background-color: #eee;
    }

    /* 오류 상태일 때 */
.password-box.error input {
  border: 1px solid #e74c3c;
  background-color: #fff5f5;
}

/* 살짝 흔들리는 애니메이션 */
.password-box.error {
  animation: shake 0.3s ease-in-out;
}

@keyframes shake {
  0% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  50% { transform: translateX(5px); }
  75% { transform: translateX(-5px); }
  100% { transform: translateX(0); }
}`, "",{"version":3,"sources":["webpack://./static/css/notice.css"],"names":[],"mappings":"GAAG;KACE,gBAAgB;KAChB,cAAc;GAChB;;GAEA,gBAAgB;GAChB;KACE,aAAa;KACb,8BAA8B;KAC9B,mBAAmB;KACnB,iBAAiB;KACjB,oBAAoB;KACpB,6BAA6B;GAC/B;;GAEA;KACE,iBAAiB;KACjB,SAAS;GACX;;GAEA;KACE,aAAa;KACb,mBAAmB;KACnB,sBAAsB;KACtB,iBAAiB;KACjB,kBAAkB;GACpB;;GAEA;KACE,YAAY;KACZ,aAAa;KACb,gBAAgB;GAClB;;GAEA,WAAW;GACX;KACE,gBAAgB;KAChB,UAAU;KACV,SAAS;GACX;;GAEA;KACE,mBAAmB;GACrB;;GAEA;KACE,aAAa;KACb,8BAA8B;KAC9B,mBAAmB;KACnB,eAAe;KACf,6BAA6B;KAC7B,eAAe;GACjB;;GAEA;KACE,OAAO;KACP,gBAAgB;GAClB;;GAEA;KACE,aAAa;KACb,SAAS;KACT,iBAAiB;KACjB,WAAW;KACX,mBAAmB;GACrB;;GAEA,WAAW;GACX;;;;;;;;;;;;;;;;;;;;MAoBG;;GAEH,QAAQ;;;GAGR;KACE,gCAAgC;KAChC,eAAe;GACjB;;GAEA;KACE,mBAAmB;GACrB;;;GAGA;KACE,eAAe;KACf,gBAAgB;KAChB,eAAe;KACf,gBAAgB;KAChB,kBAAkB;KAClB,YAAY;KACZ,kBAAkB;GACpB;;GAEA;KACE,YAAY;KACZ,kBAAkB;KAClB,WAAW;KACX,iBAAiB;KACjB,eAAe;KACf,cAAc;KACd,0BAA0B;GAC5B;;GAEA;KACE,YAAY;KACZ,eAAe;GACjB;;GAEA;KACE,gBAAgB;KAChB,eAAe;KACf,WAAW;KACX,gBAAgB;KAChB,kBAAkB;KAClB,aAAa;GACf;;GAEA;KACE,cAAc;KACd,gBAAgB;KAChB,iBAAiB;GACnB;;GAEA;KACE,cAAc;KACd,gBAAgB;KAChB,iBAAiB;GACnB;;GAEA,SAAS;GACT;KACE,WAAW;KACX,gBAAgB;KAChB,cAAc;KACd,iBAAiB;KACjB,6BAA6B;KAC7B,mBAAmB;GACrB;;GAEA,2BAA2B;GAC3B;;;MAGG;;GAEH,UAAU;GACV;KACE,6BAA6B;KAC7B,oBAAoB;KACpB,mBAAmB;GACrB;;GAEA;KACE,aAAa;KACb,8BAA8B;KAC9B,eAAe;KACf,WAAW;GACb;;GAEA,sBAAsB;GACtB;;MAEG;;GAEH,OAAO;GACP;KACE,eAAe;KACf,gBAAgB;KAChB,mBAAmB;KACnB,qBAAqB;GACvB;;GAEA,SAAS;GACT;KACE,mBAAmB;KACnB,iBAAiB;GACnB;;GAEA;KACE,qBAAqB;KACrB,iBAAiB;KACjB,sBAAsB;KACtB,kBAAkB;KAClB,eAAe;KACf,cAAc;KACd,qBAAqB;KACrB,mBAAmB;GACrB;;;GAGA;KACE,cAAc;KACd,sBAAsB;GACxB;;GAEA,OAAO;GACP;KACE,kBAAkB;KAClB,0BAA0B;KAC1B,sBAAsB;KACtB,mBAAmB;GACrB;;GAEA;KACE,gBAAgB;KAChB,kBAAkB;KAClB,sBAAsB;KACtB,kBAAkB;KAClB,eAAe;KACf,eAAe;GACjB;;GAEA;KACE,WAAW;GACb;;GAEA;KACE,mBAAmB;GACrB;;GAEA;KACE,WAAW;GACb;;GAEA,QAAQ;GACR,sBAAsB;GACtB;KACE,WAAW;KACX,gBAAgB;KAChB,cAAc;KACd,iBAAiB;GACnB;;GAEA;KACE,WAAW;KACX,gBAAgB;KAChB,cAAc;KACd,aAAa;KACb,sBAAsB;KACtB,6BAA6B;KAC7B,mBAAmB;KACnB,uBAAuB;GACzB;;GAEA,sBAAsB;GACtB;KACE,WAAW;KACX,gBAAgB;KAChB,cAAc;KACd,iBAAiB;GACnB;;;GAGA;KACE,WAAW;KACX,gBAAgB;KAChB,cAAc;KACd,aAAa;KACb,sBAAsB;KACtB,kBAAkB;KAClB,6BAA6B;KAC7B,mBAAmB;KACnB,uBAAuB;KACvB,mBAAmB;KACnB,8BAA8B;KAC9B,kBAAkB;KAClB,kBAAkB;KAClB,yCAAyC;GAC3C;;GAEA;KACE,eAAe;KACf,iBAAiB;KACjB,mBAAmB;GACrB;;GAEA;KACE,aAAa;KACb,8BAA8B;KAC9B,mBAAmB;GACrB;;GAEA;KACE,gBAAgB;KAChB,WAAW;GACb;;GAEA,sBAAsB;GACtB;KACE,uBAAuB;KACvB,WAAW;GACb;;GAEA;KACE,oBAAoB;KACpB,mBAAmB;KACnB,QAAQ;GACV;;GAEA;KACE,iBAAiB;GACnB;;GAEA;KACE,cAAc;KACd,gBAAgB;KAChB,eAAe;KACf,cAAc;KACd,sBAAsB;KACtB,kBAAkB;KAClB,iBAAiB;KACjB,kBAAkB;KAClB,mBAAmB;KACnB,wCAAwC;KACxC,eAAe;KACf,gBAAgB;GAClB;;GAEA;KACE,mBAAmB;GACrB;;GAEA,QAAQ;GACR;;;;;;;;;;;;;;;;MAgBG;;;;GAIH;;KAEE,yBAAyB;KACzB;;;QAGG;;KAEH;OACE,sBAAsB;OACtB,uBAAuB;;KAEzB;;KAEA;OACE,4BAA4B;OAC5B,wBAAwB;KAC1B;;KAEA,eAAe;KACf;;;;QAIG;KACH,yBAAyB;KACzB;OACE,eAAe;OACf,YAAY;OACZ,iBAAiB;KACnB;;KAEA;OACE,cAAc;KAChB;;KAEA,6BAA6B;;KAE7B,gBAAgB;KAChB;OACE,uBAAuB;OACvB,SAAS;OACT,oBAAoB;KACtB;;KAEA;OACE,iBAAiB;KACnB;;KAEA;OACE,YAAY;OACZ,iBAAiB;KACnB;;KAEA;OACE,WAAW;KACb;;KAEA,QAAQ;KACR;OACE,sBAAsB;OACtB,uBAAuB;OACvB,QAAQ;KACV;;KAEA;OACE,WAAW;OACX,kBAAkB;KACpB;;KAEA;OACE,SAAS;OACT,iBAAiB;OACjB,eAAe;KACjB;;KAEA,WAAW;KACX;OACE,SAAS;OACT,gBAAgB;KAClB;;KAEA;OACE,iBAAiB;KACnB;;KAEA,QAAQ;KACR;OACE,eAAe;OACf,kBAAkB;KACpB;;KAEA;OACE,WAAW;OACX,eAAe;KACjB;;KAEA;OACE,kBAAkB;OAClB,eAAe;KACjB;;KAEA,iBAAiB;KACjB;OACE,oBAAoB;OACpB,mBAAmB;KACrB;;KAEA;OACE,sBAAsB;OACtB,uBAAuB;OACvB,QAAQ;OACR,eAAe;KACjB;;KAEA;OACE,eAAe;OACf,gBAAgB;OAChB,mBAAmB;KACrB;;KAEA;OACE,gBAAgB;OAChB,eAAe;KACjB;;KAEA;OACE,eAAe;OACf,gBAAgB;KAClB;;KAEA,OAAO;KACP;OACE,gBAAgB;KAClB;;KAEA;OACE,WAAW;OACX,gBAAgB;OAChB,eAAe;OACf,eAAe;KACjB;GACF;;GAEA,aAAa;GACb,+BAA+B;GAC/B;KACE,gBAAgB;KAChB,UAAU;KACV,SAAS;KACT,0BAA0B;GAC5B;;GAEA;KACE,kBAAkB;KAClB,6BAA6B;KAC7B,aAAa;KACb,sBAAsB;KACtB,gBAAgB;GAClB;;GAEA;KACE,mBAAmB;GACrB;;;GAGA;KACE,aAAa;KACb,8BAA8B;KAC9B,uBAAuB;KACvB,SAAS;GACX;;GAEA;KACE,aAAa;KACb,mBAAmB;KACnB,eAAe;KACf,eAAe;KACf,gBAAgB;KAChB,cAAc;KACd,QAAQ;KACR,OAAO;KACP,YAAY;KACZ,qBAAqB;GACvB;;GAEA;KACE,cAAc;GAChB;;GAEA;KACE,eAAe;KACf,WAAW;GACb;;;;GAIA,UAAU;GACV;KACE,eAAe;KACf,gBAAgB;KAChB,cAAc;KACd,mBAAmB;KACnB,iBAAiB;KACjB,mBAAmB;KACnB,mBAAmB;KACnB,cAAc;GAChB;;GAEA,WAAW;GACX;KACE,eAAe;KACf,gBAAgB;KAChB,cAAc;KACd,mBAAmB;KACnB,iBAAiB;KACjB,mBAAmB;KACnB,mBAAmB;KACnB,cAAc;GAChB;;GAEA;KACE,aAAa;KACb,SAAS;KACT,eAAe;KACf,eAAe;KACf,WAAW;GACb;;GAEA;KACE,mBAAmB;GACrB;;GAEA,QAAQ;GACR;KACE;OACE,uBAAuB;OACvB,QAAQ;KACV;;KAEA;OACE,oBAAoB;OACpB,mBAAmB;OACnB,eAAe;OACf,gBAAgB;KAClB;;KAEA;OACE,oBAAoB;OACpB,mBAAmB;OACnB,eAAe;OACf,gBAAgB;KAClB;;KAEA;OACE,eAAe;KACjB;;KAEA;OACE,uBAAuB;OACvB,eAAe;KACjB;GACF;;GAEA;KACE,mBAAmB;GACrB;;GAEA,kBAAkB;GAClB;KACE,eAAe;KACf,gBAAgB;KAChB,cAAc;KACd,QAAQ;KACR,mBAAmB;KACnB,iBAAiB;KACjB,mBAAmB;KACnB,mBAAmB;GACrB;;GAEA,QAAQ;GACR;KACE;OACE,iBAAiB;KACnB;;KAEA;OACE,eAAe;OACf,eAAe;KACjB;;KAEA;OACE,gBAAgB;OAChB,eAAe;KACjB;;KAEA;OACE,sBAAsB;OACtB,QAAQ;OACR,eAAe;KACjB;GACF;;;GAGA,6BAA6B;GAC7B;KACE,iBAAiB;KACjB,iBAAiB;KACjB,UAAU;KACV,YAAY;KACZ,aAAa;KACb,kBAAkB;KAClB,uCAAuC;GACzC;;IAEC;uCACmC;GACpC;KACE,gBAAgB;KAChB,iBAAiB;KACjB,qBAAqB;KACrB,+BAA+B;KAC/B,mBAAmB;KACnB,kBAAkB;KAClB,sBAAsB;GACxB;;GAEA;KACE,eAAe;KACf,gBAAgB;KAChB,mBAAmB;GACrB;;GAEA;KACE,aAAa;KACb,sBAAsB;KACtB,SAAS;GACX;;GAEA;KACE,aAAa;KACb,sBAAsB;KACtB,QAAQ;GACV;;GAEA;KACE,gBAAgB;KAChB,mBAAmB;KACnB,wBAAwB;KACxB,qBAAqB;KACrB,oFAA6M;KAC7M,qBAAqB;KACrB,mBAAmB;KACnB,cAAc;GAChB;;GAEA;KACE,gBAAgB;KAChB,kBAAkB;GACpB;;GAEA;;;KAGE,kBAAkB;KAClB,+BAA+B;KAC/B,kBAAkB;KAClB,eAAe;KACf,sBAAsB;KACtB,oBAAoB;KACpB,kBAAkB;GACpB;;IAEC,uBAAuB;GACxB;KACE,gBAAgB;KAChB,iBAAiB;KACjB,gBAAgB;GAClB;;GAEA,SAAS;GACT;KACE,aAAa;KACb,sBAAsB;GACxB;;GAEA;KACE,aAAa;KACb,mBAAmB;KACnB,8BAA8B;KAC9B,+BAA+B;KAC/B,kBAAkB;KAClB,iBAAiB;KACjB,gBAAgB;GAClB;;GAEA;KACE,WAAW;KACX,eAAe;GACjB;;GAEA;KACE,gBAAgB;KAChB,iBAAiB;KACjB,kBAAkB;KAClB,eAAe;KACf,gBAAgB;KAChB,eAAe;KACf,gBAAgB;GAClB;;GAEA;KACE,YAAY;GACd;;GAEA;KACE,eAAe;KACf,gBAAgB;KAChB,mBAAmB;GACrB;;;GAGA;KACE,gBAAgB;KAChB,aAAa;KACb,sBAAsB;KACtB,QAAQ;GACV;;GAEA;KACE,aAAa;KACb,mBAAmB;KACnB,QAAQ;KACR,cAAc;KACd,eAAe;KACf,oBAAoB;KACpB,gBAAgB;GAClB;;GAEA;KACE,WAAW;KACX,YAAY;KACZ,cAAc;KACd,sBAAsB;KACtB,kBAAkB;GACpB;;GAEA;KACE,UAAU;KACV,gBAAgB;KAChB,uBAAuB;KACvB,mBAAmB;KACnB,oBAAoB;KACpB,eAAe;KACf,iBAAiB;KACjB,aAAa;KACb,mBAAmB;GACrB;;GAEA;KACE,WAAW;KACX,gBAAgB;KAChB,YAAY;KACZ,eAAe;KACf,eAAe;KACf,cAAc;KACd,cAAc;KACd,aAAa;KACb,mBAAmB;KACnB,uBAAuB;KACvB,gBAAgB;GAClB;;GAEA;KACE,cAAc;GAChB;;GAEA,cAAc;GACd;KACE,uBAAuB;GACzB;;GAEA,qCAAqC;GACrC;KACE,OAAO;KACP,sBAAsB;KACtB,kBAAkB;KAClB,yBAAyB;KACzB,aAAa;KACb,kBAAkB;KAClB,WAAW;KACX,iBAAiB;KACjB,aAAa;KACb,aAAa;KACb,uBAAuB;KACvB,mBAAmB;KACnB,gBAAgB;GAClB;;GAEA,mBAAmB;GACnB;KACE,eAAe;KACf,gBAAgB;KAChB,mBAAmB;KACnB,kBAAkB;GACpB;;GAEA,UAAU;GACV;KACE,aAAa;KACb,yBAAyB;KACzB,SAAS;KACT,gBAAgB;GAClB;;GAEA,2BAA2B;GAC3B;KACE,YAAY;KACZ,kBAAkB;KAClB,kBAAkB;KAClB,eAAe;KACf,gBAAgB;KAChB,eAAe;KACf,qBAAqB;GACvB;;EAED;KACG,yBAAyB;KACzB,WAAW;GACb;;GAEA;KACE,gBAAgB;KAChB,WAAW;GACb;;GAEA;KACE,YAAY;GACd;;GAEA;KACE;OACE,kBAAkB;OAClB,iBAAiB;KACnB;;KAEA;OACE,eAAe;KACjB;;KAEA;OACE,sBAAsB;OACtB,uBAAuB;OACvB,QAAQ;KACV;GACF;;GAEA,+BAA+B;;GAE/B,OAAO;GACP;MACG,aAAa,EAAE,WAAW;KAC3B,eAAe;KACf,MAAM;KACN,OAAO;KACP,WAAW;KACX,YAAY;KACZ,8BAA8B;KAC9B,aAAa;KACb,uBAAuB;KACvB,mBAAmB;KACnB,aAAa;GACf;;GAEA,UAAU;GACV;KACE,kBAAkB;KAClB,gBAAgB;KAChB,mBAAmB;KACnB,kBAAkB;KAClB,YAAY;KACZ,yCAAyC;KACzC,uCAAuC;GACzC;;KAEE;MACC,YAAY;MACZ,kBAAkB;MAClB,sBAAsB;MACtB,kBAAkB;MAClB,kBAAkB;MAClB,sCAAsC;MACtC,sBAAsB;IACxB;;IAEA;MACE,eAAe;MACf,kBAAkB;MAClB,gBAAgB;IAClB;;IAEA;MACE,eAAe;MACf,WAAW;MACX,mBAAmB;MACnB,gBAAgB;IAClB;;IAEA;MACE,UAAU;MACV,YAAY;MACZ,sBAAsB;MACtB,kBAAkB;MAClB,mBAAmB;IACrB;;IAEA;MACE,aAAa;MACb,uBAAuB;MACvB,SAAS;IACX;;IAEA;MACE,iBAAiB;MACjB,sBAAsB;MACtB,yBAAyB;MACzB,kBAAkB;MAClB,eAAe;MACf,eAAe;IACjB;;IAEA;MACE,sBAAsB;IACxB;;IAEA,aAAa;AACjB;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,iCAAiC;AACnC;;AAEA;EACE,KAAK,wBAAwB,EAAE;EAC/B,MAAM,2BAA2B,EAAE;EACnC,MAAM,0BAA0B,EAAE;EAClC,MAAM,2BAA2B,EAAE;EACnC,OAAO,wBAAwB,EAAE;AACnC","sourcesContent":["   .notice-section {\n     max-width: 900px;\n     margin: 0 auto;\n   }\n\n   /* 상단 제목 + 검색창 */\n   .notice-header {\n     display: flex;\n     justify-content: space-between;\n     align-items: center;\n     padding: 40px 0px;\n     padding-bottom: 15px;\n     border-bottom: 1px solid #ccc;\n   }\n\n   .notice-header h2 {\n     font-size: 1.5rem;\n     margin: 0;\n   }\n\n   .search-box {\n     display: flex;\n     align-items: center;\n     border: 1px solid #ccc;\n     padding: 8px 16px;\n     border-radius: 4px;\n   }\n\n   .search-box input {\n     border: none;\n     outline: none;\n     margin-left: 5px;\n   }\n\n   /* 리스트 영역 */\n   .notice-list {\n     list-style: none;\n     padding: 0;\n     margin: 0;\n   }\n\n   .notice-list li:hover {\n     background: #f9f9f9;\n   }\n\n   .notice-list li {\n     display: flex;\n     justify-content: space-between;\n     align-items: center;\n     padding: 12px 0;\n     border-bottom: 1px solid #eee;\n     cursor: pointer;\n   }\n\n   .notice-title {\n     flex: 1;\n     text-align: left;\n   }\n\n   .notice-meta {\n     display: flex;\n     gap: 30px;\n     font-size: 0.9rem;\n     color: #555;\n     white-space: nowrap;\n   }\n\n   /* 페이지네이션 */\n   /* .pagination {\n     display: flex;\n     justify-content: center;\n     align-items: center;\n     gap: 15px;\n     margin: 25px 0 0;\n     padding-bottom: 20px;\n   }\n\n   .pagination button {\n     background: none;\n     border: none;\n     font-size: 1rem;\n     cursor: pointer;\n     color: #000;\n   }\n\n   .pagination .active {\n     font-weight: bold;\n     text-decoration: underline;\n   } */\n\n   /* FAQ */\n\n\n   details {\n     border-bottom: 1px solid #e5e5e5;\n     padding: 30px 0;\n   }\n\n   details:hover {\n     background: #f9f9f9;\n   }\n\n\n   summary {\n     font-size: 18px;\n     font-weight: 600;\n     cursor: pointer;\n     list-style: none;\n     padding-left: 16px;\n     /* 전체 들여쓰기 */\n     position: relative;\n   }\n\n   summary::after {\n     content: '+';\n     position: absolute;\n     right: 16px;\n     font-weight: bold;\n     font-size: 24px;\n     line-height: 1;\n     transition: transform 0.3s;\n   }\n\n   details[open] summary::after {\n     content: '−';\n     font-size: 24px;\n   }\n\n   .faq-answer {\n     margin-top: 12px;\n     font-size: 15px;\n     color: #444;\n     line-height: 1.8;\n     padding-left: 16px;\n     /* 답변도 들여쓰기 */\n   }\n\n   .label-q {\n     color: #0072ce;\n     font-weight: 700;\n     margin-right: 6px;\n   }\n\n   .label-a {\n     color: #ff6600;\n     font-weight: 700;\n     margin-right: 6px;\n   }\n\n   /* post */\n   .wrap {\n     width: 100%;\n     max-width: 900px;\n     margin: 0 auto;\n     padding: 16px 0px;\n     border-bottom: 1px solid #ddd;\n     margin-bottom: 40px;\n   }\n\n   /* 2025.10.21 back css 삭제 */\n   /* .back {\n     align-items: center;\n     padding: 0px;\n   } */\n\n   /* 헤더 영역 */\n   .notice-detail-head {\n     border-bottom: 1px solid #ddd;\n     padding-bottom: 16px;\n     margin-bottom: 25px;\n   }\n\n   .notice-detail-info {\n     display: flex;\n     justify-content: space-between;\n     font-size: 14px;\n     color: #666;\n   }\n\n   /* 2025.10.21 css 삭제 */\n   /* .notice-detail-info span {\n     margin-left: 12px;\n   } */\n\n   /* 본문 */\n   .notice-detail-body {\n     font-size: 15px;\n     line-height: 1.7;\n     margin-bottom: 40px;\n     white-space: pre-line;\n   }\n\n   /* 첨부파일 */\n   .notice-detail-file {\n     margin-bottom: 20px;\n     text-align: right;\n   }\n\n   .notice-detail-file a {\n     display: inline-block;\n     padding: 6px 10px;\n     border: 1px solid #ccc;\n     border-radius: 4px;\n     font-size: 14px;\n     color: #0048FF;\n     text-decoration: none;\n     background: #f9f9f9;\n   }\n\n\n   .notice-detail-file svg {\n     flex-shrink: 0;\n     vertical-align: middle;\n   }\n\n   /* 버튼 */\n   .notice-detail-btn {\n     text-align: center;\n     /* 2025.10.21 btn css 수정 */\n     /* margin-top: 40px; */\n     margin-bottom: 40px;\n   }\n\n   .notice-detail-btn button {\n     background: #000;\n     padding: 12px 36px;\n     border: 2px solid #000;\n     border-radius: 4px;\n     font-size: 15px;\n     cursor: pointer;\n   }\n\n   .notice-detail-btn button>a {\n     color: #fff;\n   }\n\n   .notice-detail-btn button:hover {\n     background: #ffffff;\n   }\n\n   .notice-detail-btn button:hover>a {\n     color: #000;\n   }\n\n   /* 문의글 */\n   /* 2025.10.15 css 추가 */\n   .inquiry-section {\n     width: 100%;\n     max-width: 900px;\n     margin: 0 auto;\n     padding: 16px 0px;\n   }\n\n   .inquiry-section .wrap {\n     width: 100%;\n     max-width: 900px;\n     margin: 0 auto;\n     padding: 24px;\n     box-sizing: border-box;\n     border-bottom: 1px solid #ddd;\n     margin-bottom: 40px;\n     background: transparent;\n   }\n\n   /* 2025.10.15 css 추가 */\n   .answer-section {\n     width: 100%;\n     max-width: 900px;\n     margin: 0 auto;\n     padding: 16px 0px;\n   }\n\n\n   .answer-section .wrap {\n     width: 100%;\n     max-width: 900px;\n     margin: 0 auto;\n     padding: 24px;\n     box-sizing: border-box;\n     border-radius: 8px;\n     border-bottom: 1px solid #ddd;\n     margin-bottom: 40px;\n     background: transparent;\n     background: #fafafa;\n     border-left: 4px solid #0048FF;\n     border-radius: 8px;\n     padding: 24px 32px;\n     box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n   }\n\n   .post-title {\n     font-size: 20px;\n     font-weight: bold;\n     margin-bottom: 10px;\n   }\n\n   .notice-detail-info {\n     display: flex;\n     justify-content: space-between;\n     align-items: center;\n   }\n\n   .notice-detail-info .category {\n     font-weight: 600;\n     color: #333;\n   }\n\n   /* 2025.10.21 css 삭제 */\n   .notice-detail-info .meta span {\n     /* margin-left: 12px; */\n     color: #777;\n   }\n\n   .notice-detail-file a {\n     display: inline-flex;\n     align-items: center;\n     gap: 6px;\n   }\n\n   .contact-button {\n     text-align: right;\n   }\n\n   .contact {\n     color: #000000;\n     font-weight: 400;\n     font-size: 14px;\n     margin: 16px 0;\n     border: 1px solid #ddd;\n     width: fit-content;\n     padding: 6px 12px;\n     border-radius: 4px;\n     background: #f5f5f5;\n     box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n     cursor: pointer;\n     transition: 0.3s;\n   }\n\n   .contact:hover {\n     background: #e0e0e0;\n   }\n\n   /* 반응형 */\n   /* @media (max-width: 600px) {\n     .wrap {\n       padding: 20px;\n       margin: 0 12px 36px 12px;\n     }\n\n     .notice-detail-info {\n       flex-direction: column;\n       align-items: flex-start;\n\n     }\n\n     .answer-section .wrap {\n       padding: 20px 20px 20px 20px;\n       margin: 0 16px 36px 16px;\n     }\n   } */\n\n\n\n   @media (max-width: 768px) {\n\n     /* 2025.10.21 css 위치 수정 */\n     /* .wrap {\n       padding: 20px;\n       margin: 0 12px 36px 12px;\n     } */\n\n     .notice-detail-info {\n       flex-direction: column;\n       align-items: flex-start;\n\n     }\n\n     .answer-section .wrap {\n       padding: 20px 20px 20px 20px;\n       margin: 0 16px 36px 16px;\n     }\n\n     /* 공지사항 전체 영역 */\n     /* .notice-section,\n     .wrap {\n       max-width: 100%;\n       padding: 0 16px;\n     } */\n     /* 2025.10.21 게시판 영역 수정 */\n     .notice-section {\n       max-width: 100%;\n       margin: 16px;\n       padding-top: 16px;\n     }\n\n     .wrap {\n       margin: 0 16px;\n     }\n\n     /* ------------------------ */\n\n     /* 상단 제목 + 검색창 */\n     .notice-header {\n       align-items: flex-start;\n       gap: 15px;\n       padding: 30px 0 15px;\n     }\n\n     .notice-header h2 {\n       font-size: 1.3rem;\n     }\n\n     .search-box {\n       width: 300px;\n       padding: 6px 12px;\n     }\n\n     .search-box input {\n       width: 100%;\n     }\n\n     /* 리스트 */\n     .notice-list li {\n       flex-direction: column;\n       align-items: flex-start;\n       gap: 6px;\n     }\n\n     .notice-title {\n       width: 100%;\n       font-size: 0.95rem;\n     }\n\n     .notice-meta {\n       gap: 15px;\n       font-size: 0.8rem;\n       flex-wrap: wrap;\n     }\n\n     /* 페이지네이션 */\n     .pagination {\n       gap: 10px;\n       margin-top: 20px;\n     }\n\n     .pagination button {\n       font-size: 0.9rem;\n     }\n\n     /* FAQ */\n     summary {\n       font-size: 16px;\n       padding-left: 10px;\n     }\n\n     summary::after {\n       right: 10px;\n       font-size: 20px;\n     }\n\n     .faq-answer {\n       padding-left: 10px;\n       font-size: 14px;\n     }\n\n     /* 게시글(post) 상세 */\n     .notice-detail-head {\n       padding-bottom: 12px;\n       margin-bottom: 20px;\n     }\n\n     .notice-detail-info {\n       flex-direction: column;\n       align-items: flex-start;\n       gap: 6px;\n       font-size: 13px;\n     }\n\n     .notice-detail-body {\n       font-size: 14px;\n       line-height: 1.6;\n       margin-bottom: 30px;\n     }\n\n     .notice-detail-file {\n       text-align: left;\n       font-size: 13px;\n     }\n\n     .notice-detail-file a {\n       font-size: 13px;\n       padding: 6px 8px;\n     }\n\n     /* 버튼 */\n     .notice-detail-btn {\n       margin-top: 30px;\n     }\n\n     .notice-detail-btn button {\n       width: 100%;\n       max-width: 300px;\n       padding: 12px 0;\n       font-size: 14px;\n     }\n   }\n\n   /* 문의사항 페이지 */\n   /* 2025.10.15 문의사항 페이지 css 옮김 */\n   .contact-list {\n     list-style: none;\n     padding: 0;\n     margin: 0;\n     border-top: 1px solid #ddd;\n   }\n\n   .contact-list li {\n     padding: 16px 12px;\n     border-bottom: 1px solid #ddd;\n     display: flex;\n     flex-direction: column;\n     transition: 0.2s;\n   }\n\n   .contact-list li:hover {\n     background: #f9f9f9;\n   }\n\n\n   .contact-header {\n     display: flex;\n     justify-content: space-between;\n     align-items: flex-start;\n     gap: 12px;\n   }\n\n   .contact-title {\n     display: flex;\n     align-items: center;\n     flex-wrap: wrap;\n     font-size: 16px;\n     font-weight: 500;\n     color: #272727;\n     gap: 8px;\n     flex: 1;\n     min-width: 0;\n     word-break: break-all;\n   }\n\n   .contact-title svg {\n     flex-shrink: 0;\n   }\n\n   .contact-status {\n     font-size: 14px;\n     color: #777;\n   }\n\n\n\n   /*'답변완료' */\n   .answer-status {\n     font-size: 14px;\n     font-weight: 500;\n     color: #008000;\n     background: #e9f6eb;\n     padding: 4px 10px;\n     border-radius: 12px;\n     white-space: nowrap;\n     flex-shrink: 0;\n   }\n\n   /* '답변대기' */\n   .answer-status2 {\n     font-size: 14px;\n     font-weight: 500;\n     color: #a30000;\n     background: #f6e9e9;\n     padding: 4px 10px;\n     border-radius: 12px;\n     white-space: nowrap;\n     flex-shrink: 0;\n   }\n\n   .contact-meta {\n     display: flex;\n     gap: 12px;\n     margin-top: 6px;\n     font-size: 14px;\n     color: #777;\n   }\n\n   .contact-meta span {\n     white-space: nowrap;\n   }\n\n   /* 반응형 */\n   @media (max-width: 600px) {\n     .contact-header {\n       align-items: flex-start;\n       gap: 6px;\n     }\n\n     .answer-status {\n       align-self: flex-end;\n       /* ✅ 모바일에서 오른쪽 유지 */\n       font-size: 13px;\n       padding: 3px 8px;\n     }\n\n     .answer-status2 {\n       align-self: flex-end;\n       /* ✅ 모바일에서 오른쪽 유지 */\n       font-size: 13px;\n       padding: 3px 8px;\n     }\n\n     .contact-title {\n       font-size: 14px;\n     }\n\n     .contact-meta {\n       align-items: flex-start;\n       font-size: 13px;\n     }\n   }\n\n   .contact-meta span {\n     white-space: nowrap;\n   }\n\n   /* 오른쪽 '답변완료' 표시 */\n   .answer-status {\n     font-size: 14px;\n     font-weight: 500;\n     color: #008000;\n     /* 초록색 */\n     background: #e9f6eb;\n     padding: 4px 10px;\n     border-radius: 12px;\n     white-space: nowrap;\n   }\n\n   /* 반응형 */\n   @media (max-width: 600px) {\n     .contact-list li {\n       padding: 12px 8px;\n     }\n\n     .contact-title {\n       font-size: 14px;\n       flex-wrap: wrap;\n     }\n\n     .contact-status {\n       margin-left: 4px;\n       font-size: 13px;\n     }\n\n     .contact-meta {\n       flex-direction: column;\n       gap: 4px;\n       font-size: 13px;\n     }\n   }\n\n\n   /* 2025.10.22 문의글 작성 css 추가 */\n   :root {\n     --accent: #0048ff;\n     --border: #e5e5e5;\n     --bg: #fff;\n     --text: #222;\n     --muted: #888;\n     --file-bg: #f8f9fc;\n     font-family: \"Noto Sans KR\", sans-serif;\n   }\n\n    /* 2025.10.24 class 변경\n    inquiry-section > inquiry-contect */\n   .inquiry-contect {\n     max-width: 900px;\n     margin: 60px auto;\n     background: var(--bg);\n     border: 1px solid var(--border);\n     border-radius: 12px;\n     padding: 40px 50px;\n     box-sizing: border-box;\n   }\n\n   .inquiry-contect h2 {\n     font-size: 24px;\n     font-weight: 700;\n     margin-bottom: 28px;\n   }\n\n   .inquiry-form {\n     display: flex;\n     flex-direction: column;\n     gap: 22px;\n   }\n\n   .form-group {\n     display: flex;\n     flex-direction: column;\n     gap: 8px;\n   }\n\n   .form-group select {\n     appearance: none;\n     /* 브라우저 기본 화살표 제거 */\n     -webkit-appearance: none;\n     -moz-appearance: none;\n     background: #fff url(\"data:image/svg+xml;utf8,<svg fill='%23888' height='18' viewBox='0 0 24 24' width='18' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>\") no-repeat right 14px center;\n     background-size: 18px;\n     padding-right: 40px;\n     /* 화살표 공간 확보 */\n   }\n\n   .form-group label {\n     font-weight: 600;\n     color: var(--text);\n   }\n\n   .form-group input[type=\"text\"],\n   .form-group textarea,\n   .form-group select {\n     padding: 12px 14px;\n     border: 1px solid var(--border);\n     border-radius: 8px;\n     font-size: 15px;\n     box-sizing: border-box;\n     font-family: inherit;\n     color: var(--text);\n   }\n\n    /* 2025.10.27 css명 수정 */\n   .form-group textarea {\n     resize: vertical;\n     min-height: 180px;\n     line-height: 1.6;\n   }\n\n   /* 첨부파일 */\n   .file-box {\n     display: flex;\n     flex-direction: column;\n   }\n\n   .file-input-wrapper {\n     display: flex;\n     align-items: center;\n     justify-content: space-between;\n     border: 1px solid var(--border);\n     border-radius: 8px;\n     padding: 8px 14px;\n     background: #fff;\n   }\n\n   .file-placeholder {\n     color: #777;\n     font-size: 14px;\n   }\n\n   .file-btn {\n     background: #ddd;\n     padding: 8px 16px;\n     border-radius: 6px;\n     font-size: 14px;\n     font-weight: 600;\n     cursor: pointer;\n     transition: 0.2s;\n   }\n\n   .file-btn:hover {\n     opacity: 0.9;\n   }\n\n   .file-info {\n     font-size: 13px;\n     margin-left: 6px;\n     color: var(--muted);\n   }\n\n\n   .file-list {\n     margin-top: 10px;\n     display: flex;\n     flex-direction: column;\n     gap: 4px;\n   }\n\n   .file-item {\n     display: flex;\n     align-items: center;\n     gap: 4px;\n     padding: 4px 0;\n     font-size: 14px;\n     color: var(--accent);\n     line-height: 1.4;\n   }\n\n   .file-item svg {\n     width: 14px;\n     height: 14px;\n     flex-shrink: 0;\n     vertical-align: middle;\n     margin-top: -0.5px;\n   }\n\n   .file-item .file-name {\n     flex: none;\n     overflow: hidden;\n     text-overflow: ellipsis;\n     white-space: nowrap;\n     color: var(--accent);\n     cursor: pointer;\n     margin-right: 4px;\n     display: flex;\n     align-items: center;\n   }\n\n   .file-item .remove-btn {\n     color: #999;\n     background: none;\n     border: none;\n     font-size: 15px;\n     cursor: pointer;\n     padding: 0 2px;\n     line-height: 1;\n     display: flex;\n     align-items: center;\n     justify-content: center;\n     transition: 0.2s;\n   }\n\n   .file-item .remove-btn:hover {\n     color: #ff4444;\n   }\n\n   /* 미리보기 행 확장 */\n   .preview-row {\n     align-items: flex-start;\n   }\n\n   /* 기존 editor-area 대신 새 preview-area */\n   .preview-area {\n     flex: 1;\n     border: 1px solid #ccc;\n     border-radius: 6px;\n     background-color: #f6f8fb;\n     padding: 20px;\n     text-align: center;\n     color: #555;\n     min-height: 300px;\n     /* 기본 높이 크게 */\n     display: flex;\n     justify-content: center;\n     align-items: center;\n     overflow: hidden;\n   }\n\n   /* 업로드된 이미지 미리보기용 */\n   .preview-area img {\n     max-width: 100%;\n     max-height: 100%;\n     object-fit: contain;\n     border-radius: 4px;\n   }\n\n   /* 버튼 영역 */\n   .form-buttons {\n     display: flex;\n     justify-content: flex-end;\n     gap: 10px;\n     margin-top: 30px;\n   }\n\n   /* 2025.10.27 버튼 class 수정 */\n   .buttons-form {\n     border: none;\n     padding: 12px 28px;\n     border-radius: 8px;\n     font-size: 15px;\n     font-weight: 600;\n     cursor: pointer;\n     transition: 0.2s ease;\n   }\n\n  .buttons-form .submit {\n     background: var(--accent);\n     color: #fff;\n   }\n\n   .buttons-form .cancel {\n     background: #ddd;\n     color: #333;\n   }\n\n   .buttons-form:hover {\n     opacity: 0.9;\n   }\n\n   @media (max-width: 768px) {\n     .inquiry-section {\n       padding: 24px 20px;\n       margin: 40px 12px;\n     }\n\n     .inquiry-section h2 {\n       font-size: 20px;\n     }\n\n     .file-upload-wrapper {\n       flex-direction: column;\n       align-items: flex-start;\n       gap: 6px;\n     }\n   }\n\n   /* 2025.10.23 비밀번호 입력란 css 추가 */\n\n   /* 배경 */\n   .popup-overlay {\n      display: none; /* 기본 비표시 */\n     position: fixed;\n     top: 0;\n     left: 0;\n     width: 100%;\n     height: 100%;\n     background: rgba(0, 0, 0, 0.5);\n     display: flex;\n     justify-content: center;\n     align-items: center;\n     z-index: 1000;\n   }\n\n   /* 팝업 본체 */\n   .popup-content {\n     position: relative;\n     background: #fff;\n     border-radius: 12px;\n     padding: 30px 40px;\n     width: 600px;\n     box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n     font-family: \"Noto Sans KR\", sans-serif;\n   }\n\n     .password-box {\n      width: 320px;\n      padding: 30px 20px;\n      border: 1px solid #ddd;\n      border-radius: 6px;\n      text-align: center;\n      box-shadow: 0 2px 6px rgba(0,0,0,0.05);\n      background-color: #fff;\n    }\n\n    .password-box h2 {\n      font-size: 18px;\n      margin-bottom: 8px;\n      font-weight: 600;\n    }\n\n    .password-box p {\n      font-size: 14px;\n      color: #333;\n      margin-bottom: 16px;\n      font-weight: 500;\n    }\n\n    .password-box input {\n      width: 70%;\n      padding: 8px;\n      border: 1px solid #ccc;\n      border-radius: 4px;\n      margin-bottom: 20px;\n    }\n\n    .button-area {\n      display: flex;\n      justify-content: center;\n      gap: 10px;\n    }\n\n    .button-area button {\n      padding: 6px 16px;\n      border: 1px solid #ccc;\n      background-color: #f9f9f9;\n      border-radius: 4px;\n      cursor: pointer;\n      font-size: 14px;\n    }\n\n    .button-area button:hover {\n      background-color: #eee;\n    }\n\n    /* 오류 상태일 때 */\n.password-box.error input {\n  border: 1px solid #e74c3c;\n  background-color: #fff5f5;\n}\n\n/* 살짝 흔들리는 애니메이션 */\n.password-box.error {\n  animation: shake 0.3s ease-in-out;\n}\n\n@keyframes shake {\n  0% { transform: translateX(0); }\n  25% { transform: translateX(-5px); }\n  50% { transform: translateX(5px); }\n  75% { transform: translateX(-5px); }\n  100% { transform: translateX(0); }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
